import React, { useState, useContext } from "react";
import { Grid, TextField, InputAdornment, IconButton } from "@material-ui/core";
import { LangContext } from "../../../Context/Langcontext";
import { makeStyles } from "@material-ui/styles";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";

const useStyle = makeStyles((theme) => ({
  textfield: {
    "& .MuiInputBase-input": {
      fontWeight: 200,
    },
  },
  label: { fontWeight: 400 },
}));

const ChangePassword = ({ setchangeDis, state, setstate }) => {
  const classes = useStyle();

  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const [values, setValues] = useState({
    showPassword: false,
    showNewPassword: false,
  });
  const handleChange = (e) => {
    setstate({ ...state, [e.target.name]: e.target.value });
    setchangeDis(false);
  };
  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClickShowNewPassword = () => {
    setValues({ ...values, showNewPassword: !values.showNewPassword });
  };

  const handleMouseDownNewPassword = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <Grid item xs={6}>
        <TextField
          id="oldpassword"
          required
          label={lang.OldPassword}
          name="oldpassword"
          type={values.showPassword ? "text" : "password"}
          fullWidth
          className={classes.textfield}
          InputLabelProps={{
            className: classes.label,
          }}
          value={state.oldpassword}
          onChange={(e) => {
            handleChange(e);
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {values.showPassword ? <MdVisibility /> : <MdVisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          id="newpassword"
          required
          type={values.showNewPassword ? "text" : "password"}
          label={lang.NewPassword}
          name="newpassword"
          fullWidth
          className={classes.textfield}
          InputLabelProps={{
            className: classes.label,
          }}
          value={state.newpassword}
          onChange={(e) => {
            handleChange(e);
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowNewPassword}
                  onMouseDown={handleMouseDownNewPassword}
                  edge="end"
                >
                  {values.showPassword ? <MdVisibility /> : <MdVisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
    </>
  );
};

export default ChangePassword;
